import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TelehealthComponent } from './telehealth.component';
import { GtmModule } from '@directives/gtm/gtm.module';
import { DlsExpansionPanelModule } from '@zelis/dls/expansion-panel';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FlexLayoutModule,
    GtmModule,
    DlsExpansionPanelModule,
    MatDividerModule,
  ],
  declarations: [TelehealthComponent],
  exports: [TelehealthComponent],
})
export class TelehealthModule {}
